<app-chip [color]="tag().color" [attr.data-testid]="'tag-chip-' + tag().id">
  {{ tag().label }}
</app-chip>
